import * as React from 'react';

const Legend: React.SFC = function (): JSX.Element {
    return (
        <div className="maps-legend">
            <div>
                <span>&#8592;</span>
                <span>Largest</span>
                <span>&#8592;</span>
                <span>Smallest</span>
                <span>&#8592;</span>
            </div>
        </div>
    );
};

export default Legend;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/legend/legend.tsx